export const projectData = [
  {
    title: "message-frontend",
    description: "frontend view of a simple messaging app",
    githubLink: "https://github.com/Izzy4999/message-frontend",
    liveSite: "",
  },
  {
    title: "message-backend",
    description: "backend of the messaging app",
    githubLink: "https://github.com/Izzy4999/messaging-backend",
    liveSite: "",
  },
  {
    title: "social-backend",
    description: "backend of the simple social",
    githubLink: "https://github.com/Izzy4999/messaging-backend",
    liveSite: "",
  },
  {
    title: "social-frontend",
    description: "View of the simple social",
    githubLink: "https://social-front-end-pi.vercel.app/",
    liveSite: "https://fiit-tech-social-app.web.app/",
  },
  {
    title: "Quiz app",
    description: "A simple react and Node js quiz app",
    githubLink: "https://github.com/Izzy4999/quiz_app",
    liveSite: "",
  },
  {
    title: "GPT-3",
    description: "A single page react app",
    githubLink: "https://github.com/Izzy4999/gpt_3-project",
    liveSite: "https://gpt-3-project-one.vercel.app/",
  },
    {
    title: "Vidly",
    description: "A simple movie collection app",
    githubLink: "https://github.com/Izzy4999/vidly_frontend_cod",
    liveSite: "https://vidly-frontend-ten.vercel.app/",
  },
];
